import React from 'react';
import styled from 'styled-components';

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    fontSize: '1rem'
}

const Container = styled.div`
    width: ${props => `${props.width}px`};
    background-color: ${props => props.styles.backgroundColor};
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    margin: 0.5rem 0;
    padding: 0.5rem;
    border: 1px solid var(--primary-accent-color);
    max-height: 20vh;
    overflow-y: auto;
    font-size: ${props => props.styles.fontSize};
`

const Options = props => {
    const {
        blocks,
        closeHandler,
        width,
        styles
    } = props;
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    
    let updatedBlocks = blocks.map(block => (React.cloneElement(block, {closeHandler: closeHandler})))
    return (
        <Container styles={updatedStyle} width={width}>{updatedBlocks}</Container>
    )
}

export default Options